export enum EstimationTab {
  'estimation',
  'history',
}

export enum Quarter {
  FIRST = 'first',
  SECOND = 'second',
  THIRD = 'third',
  FOURTH = 'fourth',
}
